import React, { useEffect, useState } from "react";
import LandingOnlineNavbar from "../components/landing-online/LandingOnlineNavbar";
import LandingOnlineHero from "../components/landing-online/LandingOnlineHero";
import LandingOnlineClassTypes from "../components/landing-online/LandingOnlineClassTypes";
import "../components/landing-online/LandingOnline.css";
import LandingOnlineBanner from "../components/landing-online/LandingOnlineBanner";
import LandingOnlineMetodo from "../components/landing-online/LandingOnlineMetodo";
import LandingOnlineFeatures from "../components/landing-online/LandingOnlineFeatures";
import LandingOnlineWorkoutPlanner from "../components/landing-online/LandingOnlineWorkoutPlanner";
import LandingOnlineFilters from "../components/landing-online/LandingOnlineFilters";
import LandingOnlineFavorites from "../components/landing-online/LandingOnlineFavorites";
import LandingOnlineTestimonials from "../components/landing-online/LandingOnlineTestimonials";
import LandingOnlineRewardsTeaser from "../components/landing-online/LandingOnlineRewardsTeaser";
import LandingOnlineMobileNavbar from "../components/landing-online/LandingOnlineMobileNavbar";
import Footer from "../components/global/Footer";
const LandingOnline = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div id="landing__online">
      <LandingOnlineNavbar />
      <LandingOnlineMobileNavbar />
      <LandingOnlineHero />
      <LandingOnlineBanner/>
      <LandingOnlineClassTypes />
      <LandingOnlineMetodo />
      <LandingOnlineFeatures />
      <LandingOnlineWorkoutPlanner />
      <LandingOnlineFilters />
      <LandingOnlineFavorites/>
      <LandingOnlineTestimonials />
      <LandingOnlineRewardsTeaser />
      <Footer />
      <button
        type="button"
        className={`btn btn-primary landing-online__scroll-top-btn ${
          showScrollTop ? "landing-online__scroll-top-btn--visible" : ""
        }`}
        onClick={handleScrollToTop}
        aria-label="Volver arriba"
      >
        <i className="fa fa-chevron-up" />
      </button>
    </div>
  );
};

export default LandingOnline;